export default class Bell {
  /** @var {HTMLElement} */
  container;
  applicationServerKey = 'BFI2x4x3njkKeuv8EXrCf4BniFIcpRNF7-njaT_r5TQfrFDUJ9SEZ-QnyMknto46okFeMx8BgrW43pYqCjyU5OM';
  isPushEnabled = false;
  /** @var {Node} */
  toggleDetail;
  /** @var {HTMLElement} */
  pushButton;
  #segmentHashList = [];

  skipServiceWorkerRegister = false;

  constructor(skipServiceWorkerRegister) {
    this.skipServiceWorkerRegister = skipServiceWorkerRegister;

    this.insertHtml();
    this.initialize();
  }

  insertHtml() {
    const template = document.querySelector('#tx_dppushnotification-template');
    const bell = template.content.cloneNode(true);
    document.querySelector('body').appendChild(bell);

    this.container = document.querySelector('#tx_dppushnotification');
    this.toggleDetail = document.querySelector('#tx_dppushnotification details');
    this.pushButton = document.querySelector('#tx_dppushnotification .subscription-button');
  }

  initialize() {
    if(!('serviceWorker' in navigator)) {
      console.warn('Service workers are not supported by this browser'); // eslint-disable-line no-console
      this.changePushButtonState('incompatible');
      return;
    }

    if(!('PushManager' in window)) {
      console.warn('Push notifications are not supported by this browser'); // eslint-disable-line no-console
      this.changePushButtonState('incompatible');
      return;
    }

    if(!('showNotification' in ServiceWorkerRegistration.prototype)) {
      console.warn('Notifications are not supported by this browser'); // eslint-disable-line no-console
      this.changePushButtonState('incompatible');
      return;
    }

    if(Notification.permission === 'denied') {
      console.warn('Notifications are denied by the user'); // eslint-disable-line no-console
      this.changePushButtonState('incompatible');
      return;
    }

    if(!this.skipServiceWorkerRegister) {
      navigator.serviceWorker.register(
        window.location.origin + '/service-worker.js',
        {scope: '/'}
      ).then(
        () => {
          console.log('[SW] Service worker has been registered'); // eslint-disable-line no-console
          this.fetchSubscription();
        },
        (e) => {
          console.error('[SW] Service worker registration failed', e); // eslint-disable-line no-console
          this.changePushButtonState('incompatible');
        }
      );
    }
    else {
      this.fetchSubscription();
    }

    this.container.addEventListener('submit', async (e) => {
      e.preventDefault();
      const segmentHashCheckboxList = Array.from(this.container.querySelectorAll('input[name=segmentHashList]:checked'));
      this.#segmentHashList = segmentHashCheckboxList.map((segment) => segment.value);

      if(this.isPushEnabled && this.#segmentHashList.length == 0) {
        this.unsubscribe();
      }
      else if(this.isPushEnabled && this.#segmentHashList.length > 0) {
        await this.unsubscribe();
        this.subscribe();
      }
      else if(!this.isPushEnabled && this.#segmentHashList.length > 0) {
        this.subscribe();
      }

      return false;
    });
  }

  fetchSubscription() {
    this.changePushButtonState('computing');

    navigator.serviceWorker.ready
      .then((serviceWorkerRegistration) => serviceWorkerRegistration.pushManager.getSubscription())
      .then(async (subscription) => {
        if(!subscription) {
          this.changePushButtonState('disabled');
          return;
        }
        else {
          return await this.pushSubscription(subscription, 'POST');
        }
      })
      .then((subscriptions) => {
        if(subscriptions) {
          for(let i = 0; i < subscriptions.data.length; i++) {
            const segmentData = subscriptions.data[i];
            const inputFromSegmentNodeFound = this.container.querySelector('input[value="' + segmentData.hash + '"]');

            if(inputFromSegmentNodeFound != null) {
              inputFromSegmentNodeFound.checked = true;
            }
            else {
              const divider = this.container.querySelector('.divider');
              const segmentNodeFirst = this.container.querySelector('.segment');
              if(!segmentNodeFirst) return;
              const segmentNode = segmentNodeFirst.cloneNode(true);
              const input = segmentNode.querySelector('input[name=segmentHashList]');
              input.value = segmentData.hash;
              input.checked = true;
              const span = segmentNode.querySelector('.segment-title');
              span.innerHTML = segmentData.title;
              divider.after(segmentNode);
            }
          }
        }

        this.changePushButtonState('enabled');
      })
      .catch((e) => {
        console.error('Error when updating the subscription', e); // eslint-disable-line no-console
        this.changePushButtonState('disabled');
      });
  }

  async subscribe() {
    this.changePushButtonState('computing');
    this.toggleDetail.open = false;

    return this.checkNotificationPermission()
      .then(() => navigator.serviceWorker.ready)
      .then((serviceWorkerRegistration) => serviceWorkerRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(this.applicationServerKey),
      }))
      .then((subscription) =>  this.pushSubscription(subscription, 'PUT'))
      .then((subscription) => subscription && this.changePushButtonState('enabled'))
      .catch((e) => {
        if(Notification.permission === 'denied') {
          console.warn('Notifications are denied by the user.'); // eslint-disable-line no-console
          this.changePushButtonState('incompatible');
        }
        else {
          console.error('Impossible to subscribe to push notifications', e); // eslint-disable-line no-console
          this.changePushButtonState('disabled');
        }
      });
  }

  async unsubscribe() {
    this.changePushButtonState('computing');
    this.toggleDetail.open = false;

    navigator.serviceWorker.ready
      .then((serviceWorkerRegistration) => serviceWorkerRegistration.pushManager.getSubscription())
      .then(async (subscription) => {
        if(!subscription) {
          this.changePushButtonState('disabled');
          return;
        }

        await this.pushSubscription(subscription, 'DELETE');
        await subscription.unsubscribe();
        this.changePushButtonState('disabled');
      })
      .catch((e) => {
        console.error('Error when unsubscribing the user', e); // eslint-disable-line no-console
        this.changePushButtonState('disabled');
      });
  }

  async pushSubscription(subscription, method) {
    const key = subscription.getKey('p256dh');
    const token = subscription.getKey('auth');
    const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];

    return fetch(
      window.location.href + '?sID=push-subscription' + '&segments=' + this.#segmentHashList.join(','),
      {
        method,
        body: JSON.stringify({
          endpoint: subscription.endpoint,
          publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
          authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
          contentEncoding,
        }),
      }
    ).then((response) => response.json());
  }

  changePushButtonState(state) {
    switch(state) {
    case'enabled':
      this.pushButton.setAttribute('title', 'Disable Push notifications');
      this.pushButton.textContent = '🔔';
      this.isPushEnabled = true;
      break;

    case'disabled':
      this.pushButton.setAttribute('title', 'Enable Push notifications');
      this.pushButton.textContent = '🔔';
      this.isPushEnabled = false;
      break;

    case'computing':
      this.pushButton.setAttribute('title', 'Loading...');
      this.pushButton.textContent = '💭';
      break;

    case'incompatible':
      this.pushButton.setAttribute('title', 'Push notifications are not compatible with this browser');
      this.pushButton.textContent = '🔕';
      break;

    default:
      console.error('Unhandled push button state', state); // eslint-disable-line no-console
      break;
    }
  }

  checkNotificationPermission() {
    return new Promise((resolve, reject) => {
      if(Notification.permission === 'denied') {
        return reject(new Error('Push messages are blocked.'));
      }
      else if(Notification.permission === 'granted') {
        return resolve();
      }
      else if(Notification.permission === 'default') {
        return Notification.requestPermission()
          .then((result) => {
            if(result !== 'granted') {
              reject(new Error('Bad permission result'));
            }
            else {
              resolve();
            }
          });
      }

      return reject(new Error('Unknown permission'));
    });
  }

  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for(let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }
}
